<template>
  <div>
    <b-form>
      <b-row class="mt-4">
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Name</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input id="name" v-model="updateUserForm.name" :state="nameStatus" @blur="onBlur($event)"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Username</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input id="username" v-model="updateUserForm.username" readonly></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Available Roles</span>
          </p>
        </b-col>
        <b-col xl="2" lg="2" sm="2"></b-col>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Assigned Roles</span>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <b-form-group label-for="input-1">
            <b-form-select
                id="newGroups"
                placeholder="Select options"
                v-model="newGrps"
                :options="groupOption"
                :state="customerGroupStatus"
                @change="changeGroupStatus()"
                value-field="key"
                :select-size="10"
                multiple
                text-field="label"
            ></b-form-select>
            <b-form-invalid-feedback :state="customerGroupStatus">
              Please select a valid group.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="2" sm="2" class=" mt-3 text-center mb-5">
          <b-row>
            <b-col xl="12" lg="12" sm="12">
							<span class="badge badge-pill badge-primary">
								<i class="fas fa-chevron-right p-2" @click="sendToNew"></i>
							</span>
            </b-col>
            <b-col class="mt-1" xl="12" lg="12" sm="12">
							<span class="badge badge-pill badge-primary" @click="sendToOld">
								<i class="fas fa-chevron-left p-2"></i>
							</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="5" lg="5" sm="5">
          <b-form-group label-for="input-1">
            <b-form-select
                id="oldGroups"
                placeholder="Select options"
                v-model="newGrps"
                :options="userGroups.oldGroup"
                value-field="key"
                :select-size="10"
                multiple
                text-field="label"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col xl="12">

          <p class="mt-12">
            <em>Note: Role setup notes. Please add a single Carrier role and a single Product role for a user.
              All users must have at least 1 Carrier and 1 Product role to access the portal. For example:
              Strata + CDMA_READ or NNTC + OTA_EDIT. There are 3 types of roles per product: READ, EDIT, ADMIN.
            </em>
          </p>

        </b-col>

        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Email</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
                id="email"
                type="email"
                :state="emailStatus"
                v-model="updateUserForm.email"
                @blur="onBlur($event)"
            ></b-form-input>
            <b-form-invalid-feedback :state="emailStatus">
              Please enter a valid email.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Phone</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <vue-tel-input
                v-model="updateUserForm.phone"
                placeholder="999-888-7777"
                :defaultCountry="preferredCountry"
                :enabledCountryCode="enabledCountryCodeStatus"
                :state="phoneStatus"
                :validCharactersOnly="validCharactersOnly"
                @country-changed="onSelectCountry"
                @blur="onBlur($event)"
            ></vue-tel-input>
            <b-form-invalid-feedback :state="phoneStatus">
              Please enter a valid phone number.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Reset Password</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
                id="password"
                placeholder="Reset Password"
                type="password"
                autocomplete="new-password"
                :state="passwordStatus"
                v-model="updateUserForm.password"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!passwordLength">
              Your password must have at least 8 chars.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordUppercase">
              Your password must have at least 1 upper case letter.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordNumber">
              Your password must have at least 1 number.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!passwordCharacter">
              Your password must have at least 1 special char.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr/>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="danger" title="Close"  v-on:click="modalClose()">
							Close
        </base-button>
        <base-button
          :disabled="submitDisabled"
          :loading="submitLoading"
          :title="submitDisabled? 'No Changes' : 'Save'"
          type="primary"
          v-on:click="changeGroupSubmit"
        >            Save
        </base-button>
      </div>
      
    </b-form>
  </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";
import AuthService from "@/common/api-services/auth-service";
import AdministratorService from "../../common/api-services/administrator-service";
import initService from '../../common/api-services/init-service';
import configDirective from '../../common/directive/config-directive';

export default {

  name: "Change-User",

  components: {
    VueTelInput
  },

  data() {
    return {
      accessToken: "",
      newGrps: [],
      removeUserGroups: [],
      updateUserForm: {
        name: "",
        oldName: "",
        username: "",
        oldUsername: "",
        email: "",
        oldEmail: "",
        phone: "",
        oldPhone: "",
        password: "",
      },
      userGroups: {
        newGroup: [],
        oldGroup: []
      },
      groupOption: [],
      submitLoading: false,

      enabledCountryCodeStatus: true,
      dialCode: '',
      customerIdentifier: '',
      editStatus: false,
      preferredCountry: 'us',
      validCharactersOnly: true,

    };
  },

  computed: {
    isPortalAdmin() {
      return initService.getPortalAdminRole()
    },
    customerGroupStatus() {
      return this.updateUserForm.customerGroup !== '';//'Select Group';
    },
    submitDisabled() {
      let valid = this.nameStatus || this.phoneStatus || this.emailStatus || this.usernameStatus || this.passwordStatus;
      return !valid
      return false
    },
    nameStatus() {
      if (this.updateUserForm.name === this.updateUserForm.oldName) {
        return null
      } else {
        return true
      }
    },
    phoneStatus() {
      let scrubbedPhone = this.updateUserForm.phone.replaceAll(' ','').replaceAll('-','').replaceAll('(','').replaceAll(')','')
      if (scrubbedPhone === this.updateUserForm.oldPhone) {
        return null
      }
      return scrubbedPhone.replaceAll('+','').length === 11
    },
    emailStatus() {
      if (this.updateUserForm.email.toLowerCase() === this.updateUserForm.oldEmail) {
        return null
      }
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      console.log(re.test(String(this.updateUserForm.email).toLowerCase()))
      return re.test(String(this.updateUserForm.email).toLowerCase())
    },
    usernameStatus() {
      if (this.updateUserForm.username.toLowerCase() === this.updateUserForm.oldUsername) {
        return null
      }
      return this.updateUserForm.username.length > 0
    },
    passwordStatus() {
      let valid = false;
      if (this.updateUserForm.password.length === 0) {
        valid = null;
      } else {
        valid = this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter;
      }
      return valid;
    },
    passwordLength() {
      return this.updateUserForm.password.length > 7 ? true : false;
    },
    passwordUppercase() {
      let pass = this.updateUserForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('A' <= pass[i] && pass[i] <= 'Z') {
          return true;
        }
      }
      return false;
    },
    passwordNumber() {
      let pass = this.updateUserForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('0' <= pass[i] && pass[i] <= '9') {
          return true;
        }
      }
      return false;
    },
    passwordCharacter() {
      let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(this.updateUserForm.password)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.$root.$on("ChangeUserOldData", res => {
      this.updateUserForm.name = res.name;
      this.updateUserForm.oldName = res.name;
      this.updateUserForm.username = res.userName;
      this.updateUserForm.oldUsername = res.userName;
      this.updateUserForm.email = res.email;
      this.updateUserForm.oldEmail = res.email;
      this.updateUserForm.phone = res.phone_number;
      this.updateUserForm.oldPhone = res.phone_number;
      this.userGroups.oldGroup = res.group;
      this.getSelectGroup();
    });
  },
  methods: {
    removeGroup(group) {
      this.groupOption.push({key: group, label: group});
      this.removeUserGroups.push(group);
    },
    onSelectCountry({name, iso2, dialCode}) {
      this.dialCode = dialCode
    },

    async modalClose() {
      this.$bvModal.hide("change-user");
    },

    clear() {
      //alert("clear");
      this.userGroups.newGroup = [];
      this.userGroups.oldGroup = [];
      this.removeUserGroups = [];
      this.newGrps = [];
    },

    async removeUserGroup() {
      for (let x in this.removeUserGroups) {
        await administratorService
          .removeUserFromGroup(this.updateUserForm.oldUsername, this.removeUserGroups[x])
          .then(res => {
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type})
          });
      }
    },

    async changeGroups() {
      this.submitLoading = true;
      const haveReports = this.userGroups.oldGroup.includes("REPORTS_READ");
      const isAdmin = this.userGroups.oldGroup.includes("Administrator");
      if ((haveReports && isAdmin) || (!haveReports && !isAdmin) || isAdmin) {
        if (this.userGroups.newGroup.length > 0 || this.userGroups.oldGroup.length > 0) {
          this.userGroups.newGroup.map(async newGrp => {
            await administratorService.addUserToGroup(this.updateUserForm.oldUsername, newGrp).then(res => {
              let {type, msg} = handleResponse.apiResponse(res);
              this.$toast(msg, {type: type})
            });
          });
        } else {
          await administratorService.addUserToGroup(this.updateUserForm.oldUsername, "User").then(res => {
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type})
          });
        }
        //close modal
        this.clear();
        await this.modalClose();
        this.$root.$emit("getUserList");
      } else {
        this.submitLoading = false;
        this.$toast.error("Reports only Allowed with Admin Role you need to select Admin Role Too.")
      }
    },

    getSelectGroup() {
      administratorService.getGroupList().then(res => {
        // this.groupOption.push({
        //   key: "Select Group",
        //   label: "Select Group",
        // });
        res.map((item, index) => {
          const isExist = this.userGroups.oldGroup.includes(item.GroupName);
          if(isExist || (!this.isPortalAdmin && item.GroupName === 'PORTAL_ADMIN')) return 
          this.groupOption.push({key: item.GroupName, label: item.GroupName,});
        });
      });
    }, 
    
    sendToNew() {
      this.newGrps.map(grp => {
        const isExist = this.userGroups.oldGroup.includes(grp);
        const hasPortalAdmin = this.userGroups.oldGroup.includes('PORTAL_ADMIN')
        if(hasPortalAdmin) return
        if(isExist) {
          this.$toast.info("User already have " + grp + " nav item!")
          return
        }
        const groups = this.groupOption.map(e => e.key)
        const index = groups.findIndex((e) => e === grp);
        this.groupOption.splice(index, 1);
        if(grp === 'PORTAL_ADMIN') {
          this.userGroups.oldGroup.forEach(group => this.removeGroup(group))
          this.userGroups.oldGroup.splice(0, this.userGroups.oldGroup.length)
          this.removeUserGroup()
        } 
        this.userGroups.oldGroup.push(grp);
        //add user to role.
        AdministratorService.addUserToGroup(this.updateUserForm.username, grp).then(res => {
          //console.log('addUserToGroup:',res);
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(msg, {type: type})
        });
      });
    },
    
    sendToOld() {
      this.newGrps.map(grp => {
        const isExist = this.groupOption.map(e => e.key).includes(grp);
        if (!isExist) {
          this.removeGroup(grp)
          const index = this.userGroups.oldGroup.findIndex((e) => e === grp);
          this.userGroups.oldGroup.splice(index, 1);
          //add user to role.
          AdministratorService.removeUserFromGroup(this.updateUserForm.username, grp).then(res => {
            //console.log('removeUserFromGroup:',res);
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type})
          });

        } else {
          this.$toast.info("NavItems " + grp + " already exists!")
        }
      });
    },
    changeGroupStatus() {
      this.updateUserForm.isReadOnly = this.userGroups.newGroup !== "Administrator";
    },

    formatPhoneNumber(phone) {
      phone = phone.replace(/\D/g, '');
      phone = phone.substr(phone.length - 10);
      if (phone.length < 10) {
        this.$toast.error('Error: Invalid phone length <10.')
        return phone;
      }
      phone = "+1" + phone;
      return phone;
    },

    async changeGroupSubmit() {
      if (this.passwordStatus) {
        await AdministratorService.resetUserPassword(this.updateUserForm.username, this.updateUserForm.password).then(res => {
          this.submitLoading = false;
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(msg, {type: type})
          if (type === 'error') errors = true;
        });
      }

      // if (this.customerGroupStatus && this.phoneStatus && this.emailStatus && this.usernameStatus) {
        let errors = false;
        this.submitLoading = true;
        const userArttributes = [
          {Name: 'name', Value: this.updateUserForm.name},
          {Name: 'email', Value: this.updateUserForm.email},
          {Name: 'phone_number', Value: this.formatPhoneNumber(this.updateUserForm.phone)},
        ];

        const oldUserArttributes = [
          {Name: 'name', Value: this.updateUserForm.oldName},
          {Name: 'email', Value: this.updateUserForm.oldEmail},
          {Name: 'phone_number', Value: this.formatPhoneNumber(this.updateUserForm.oldPhone)},
        ];

        if (userArttributes && userArttributes !== '' && JSON.stringify(userArttributes) !== JSON.stringify(oldUserArttributes)) {
          await AdministratorService.updateUserProfile(this.updateUserForm.username, userArttributes).then(res => {
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type})
            if (type === 'error') errors = true;
          });
        }

        //finished
        if (!errors) {
          this.$root.$emit("getUserList");
          this.modalClose();

          // update session storage if current user is updated
          if (this.updateUserForm.username === configDirective.getCurrentUser().username) {
            console.log('update session storage')
            sessionStorage.setItem('IOT_GetCurrentUser', JSON.stringify({
              ...configDirective.getCurrentUser(),
              name: this.updateUserForm.name,
              email: this.updateUserForm.email,
              phone_number: this.updateUserForm.phone,
            }))
          }

        } else {
          this.$toast('There were errors processing all the changes. You may want to save your chagnes again.', {type: type})
        }
      // }
    },

    onBlur(event) {
      if (!event) {
        if (this.updateUserForm.phone === '') {
          this.updateUserForm.phone = this.updateUserForm.oldPhone;
          return
        }
      } else {

        switch (event.target.id) {
          case 'email':
            if (this.updateUserForm.email === '') {
              this.updateUserForm.email = this.updateUserForm.oldEmail;
            }
            break;
          case 'name':
            if (this.updateUserForm.name === '') {
              // No display name is allowed
              // this.updateUserForm.name = this.updateUserForm.oldName;
            }
            break;
          case 'phone':
            if (this.updateUserForm.phone === '') {
              this.updateUserForm.phone = this.updateUserForm.oldPhone;
            }
          break;
          default:
            console.log('From default: ID =>', e.target.id)
            break;
        }
      }
    }
  },
  
};
</script>